
const SCRIPT_ID = 'recaptcha-enterprise-script';
const SCRIPT_SRC = 'https://www.google.com/recaptcha/enterprise.js?render=explicit';

export default {
  name: 'Captcha',
  props: {
    size: {
      type: String,
      default: 'normal',
    },
    theme: {
      type: String,
      default: 'light',
    },
    badge: {
      type: String,
      default: 'bottomright',
    },
    tabindex: {
      type: String,
      default: '0',
    },
    action: {
      type: String,
      default: 'contact_submit',
    },
  },
  data() {
    return {
      siteKey: process.env.CAPTCHA_SITE_KEY,
      widgetId: null,
      scriptListeners: [],
    };
  },
  mounted() {
    if (!this.siteKey) {
      console.error('reCAPTCHA site key is missing');
      return;
    }

    if (typeof window !== 'undefined' && window.grecaptcha && window.grecaptcha.enterprise) {
      this.renderRecaptcha();
    } else {
      this.injectScript();
    }
  },
  beforeDestroy() {
    this.cleanupRecaptcha();
    this.removeScriptListeners();
  },
  methods: {
    injectScript() {
      if (typeof document === 'undefined') {
        return;
      }

      const existingScript = document.getElementById(SCRIPT_ID);
      if (existingScript) {
        this.addScriptListener(existingScript, 'load', this.renderRecaptcha);
        this.addScriptListener(existingScript, 'error', this.handleScriptError);
        return;
      }

      const script = document.createElement('script');
      script.id = SCRIPT_ID;
      script.src = SCRIPT_SRC;
      script.async = true;
      script.defer = true;
      this.addScriptListener(script, 'load', this.renderRecaptcha);
      this.addScriptListener(script, 'error', this.handleScriptError);
      document.head.appendChild(script);
    },
    addScriptListener(script, event, handler) {
      script.addEventListener(event, handler);
      this.scriptListeners.push({ script, event, handler });
    },
    removeScriptListeners() {
      this.scriptListeners.forEach(({ script, event, handler }) => {
        script.removeEventListener(event, handler);
      });
      this.scriptListeners = [];
    },
    handleScriptError(error) {
      console.error('Failed to load reCAPTCHA script', error);
      this.$emit('error', error);
    },
    renderRecaptcha() {
      if (typeof window === 'undefined' || !window.grecaptcha || !window.grecaptcha.enterprise) {
        return;
      }

      window.grecaptcha.enterprise.ready(() => {
        if (!this.$refs.recaptchaContainer) {
          return;
        }

        if (this.widgetId !== null) {
          window.grecaptcha.enterprise.reset(this.widgetId);
          return;
        }

        this.widgetId = window.grecaptcha.enterprise.render(this.$refs.recaptchaContainer, {
          sitekey: this.siteKey,
          theme: this.theme,
          size: this.size,
          badge: this.badge,
          tabindex: parseInt(this.tabindex, 10) || 0,
          callback: this.handleVerify,
          'error-callback': this.handleError,
          'expired-callback': this.handleExpired,
          action: this.action,
        });
      });
    },
    handleVerify(token) {
      this.$emit('verified', token);
    },
    handleExpired() {
      this.$emit('expired');
    },
    handleError(error) {
      this.$emit('error', error);
    },
    reset() {
      if (typeof window !== 'undefined' && window.grecaptcha && window.grecaptcha.enterprise && this.widgetId !== null) {
        window.grecaptcha.enterprise.reset(this.widgetId);
      }
    },
    cleanupRecaptcha() {
      this.reset();
      this.widgetId = null;
    },
  },
};
